
import { Watch, Mixins, Component, InjectReactive } from "vue-property-decorator";
import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";

import ETable from "@/components/ETable.vue";

import { fdmNurseList, fdmNurseStatus } from "@/api/consultation";
import { StatusEnum } from "@/enum/common.enum";

import Add from "./FourNurseDialog.vue";

import { cloneDeep } from "lodash";

@Component({ name: 'fourCombine-components-fourNurse',
    components: {
        ETable, Add
    }
})
export default class ConsultationList extends Mixins(TablePagination, Resize) {
    @InjectReactive() currentTab!: string|number;
    @InjectReactive() merchantId!: string|number;

    queryForm = {
        nurseName: "",
        symptomName: "",
    }

    columns = [
        { label: "ID", prop: "id" },
        { label: "四诊调养", prop: "name",  },
        { label: "关联症状", prop: "symptomName"  },
        { label: "先导原则", prop: "preRules" },
        { label: "互斥原则", prop: "mutexRules" },
        { label: "音乐调养", prop: "nurseMusic" },
        { label: "状态", formatter: (row) => StatusEnum[row.nurseStatus] },
        { label: "操作", prop: "action" },
    ];

    tableData = [];
    itemTotal = 0;

    loading = false

    addDialogVisible = false;
    editData = {};

    tenConsultationList = [];

    organOptions = [
        "心","肺","肝","胆","肾","膀胱","胃","脾","大肠","小肠","三焦"
    ];
    

    mounted() {
        this.windowResize(350);
        // console.log("PresMusic", PresMusic)
        // this.getTenConsultationList();
    }

    handleStatusChange(row) {
        fdmNurseStatus({ fragranceId: row.id, status: Number(!row.nurseStatus) }).then(() => {
            this.getData();
        })
    }


    fdmNurseList() {
        const params = {
            ...this.queryForm,
            pageSize: this.pageSize,
            pageNum: this.currentPage,
        }
        this.loading = true;
        fdmNurseList(params).then((res) => {
            this.tableData = res.data.list;
            this.itemTotal = res.data.total;
            this.tableData?.forEach((row) => {
                row.symptomNameDesc = row.symptomName?.map(el => el.name)?.join("、")
            })
        }).finally(() => {
            this.loading = false;
        })
    }

    @Watch("currentTab", { immediate: true })
    getData() {
        if (this.currentTab != 1) return;
        this.fdmNurseList();
    }

    //重置分页参数
    resetPages() {
      this.currentPage = 1;
    }

    handleSearch() {
        this.resetPages();
        this.getData();
    }

    handleEdit(row = { nurseStatus: 1, nurseMusic: "随机" }) {
        this.addDialogVisible = true;
        this.editData = cloneDeep(row);
    }
vLoading(vLoading: any) {
throw new Error("Method not implemented.");
}
}
